import { useState, useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import DashboardNavbar from "./dashboard-navbar";
import { DashboardSidebarCustomer } from "./dashboard-sidebar-customer";
import LoginToast from "./LoginToast";

const DashboardLayoutRootCustomer = styled("div", {
    shouldForwardProp: (prop) => prop !== "isSidebarOpen"
})(({ theme, isSidebarOpen }) => ({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    paddingTop: 64,
    transition: theme.transitions.create(["padding-left"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up("lg")]: {
        paddingLeft: isSidebarOpen ? 250 : 0
    }
}));

export const DashboardLayoutCustomer = (props) => {
    const { children } = props;
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
        defaultMatches: true,
        noSsr: false
    });
    const [isSidebarOpen, setSidebarOpen] = useState(lgUp);

    useEffect(() => {
        setSidebarOpen(lgUp);
    }, [lgUp]);

    const toggleSidebar = () => {
        setSidebarOpen((prev) => !prev);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    return (
        <>
            <DashboardLayoutRootCustomer isSidebarOpen={isSidebarOpen}>
                <Box
                    sx={{
                        display: "flex",
                        flex: "1 1 auto",
                        flexDirection: "column",
                        width: "100%"
                    }}>
                    {children}
                </Box>
            </DashboardLayoutRootCustomer>
            <DashboardNavbar
                isSidebarOpen={isSidebarOpen}
                onSidebarOpen={toggleSidebar}
                callback={toggleSidebar}
            />
            <DashboardSidebarCustomer
                show={props.customer}
                onClose={closeSidebar}
                callback={closeSidebar}
                open={isSidebarOpen}
            />
            <LoginToast />
        </>
    );
};
